module.exports = __webpack_public_path__ + "img/project4_7.jpg.0188964f.webp";